import { savePDPData } from '@/redux/actions';
import { storeProductClickedDetails } from '@/utils/storeProductClickedDetails';
import { canShowPDPSystem } from '@/utils/canShowPDPSystem';
import { CLICKED_ITEM_X_OFFSET, CLICKED_ITEM_Y_OFFSET } from '@/utils/constants';
import { useSelector, useDispatch } from 'react-redux';
import { getProductPathFromUrl } from 'src/utils/productUtils';
import { getRoute } from '@/utils/routes';
import { isB2BStore } from 'src/utils/isStoreB2B';

export function useItemClick() {
  const dispatch = useDispatch();

  const { storeData } = useSelector((state) => ({
    storeData: state.storeReducer.store,
  }));

  const getProductRoute = (product) => {
    const productUrl = product?.link;
    const productRoute = getRoute(
      getProductPathFromUrl(productUrl, false),
      storeData?.store_info?.domain
    );
    return productRoute;
  };

  /**
   * to go to product description page, special characters are not allowed.
   * using regex to remove all special characters with '-'
   * @param {*} item
   * @param {*} e
   */
  const onItemClick = async (item, e = null, openInNewTab = false) => {
    storeProductClickedDetails();
    e && e?.stopPropagation();
    sessionStorage.setItem(CLICKED_ITEM_X_OFFSET, scrollX);
    sessionStorage.setItem(CLICKED_ITEM_Y_OFFSET, scrollY);

    const getRoute = await import('@/utils/routes').then((module) => module.getRoute);
    const productRoute = await getProductRoute(item, getRoute);

    /** if color is there push with color in query params */
    if (item?.color) {
      const paramStr = `?color=${item?.color}`;
      const productRouteWithParam = productRoute + paramStr;
      window.location.href = productRouteWithParam;
    } else if (!canShowPDPSystem(storeData?.theme?.theme_class) && !isB2BStore()) {
      dispatch(savePDPData({ visible: true, product: item }));
    } else {
      openInNewTab
        ? window.open(productRoute, '_blank')
        : (window.location.href = productRoute);
    }
  };

  const getLink = (item, getRoute) => {
    if (!item) {
      return;
    }
    const productRoute = getProductRoute(item, getRoute);
    const productLink = '';

    if (item?.color) {
      const paramStr = `?color=${item?.color}`;
      productLink = productRoute + paramStr;
    } else if (canShowPDPSystem(storeData?.theme?.theme_class)) {
      productLink = productRoute;
    }

    return productLink || '';
  };

  return [onItemClick, getLink];
}
